import type { BadgeTone } from '@shared/ui/badge';

import type { InvestStatusBadgeType } from '../model/invest-status';

/**
 * 투자 상태 · 회수 값 → Badge tone. InvestStatusBadge · ExitBadge 가 같은 표를 쓴다.
 * 회수 = primary, 부분회수 = neutral(중간 회색), 감액 계열 = info, 폐업 계열 = warning
 */
export const INVEST_STATUS_BADGE_TONE: Record<InvestStatusBadgeType, BadgeTone> = {
  'complete-exit': 'primary',
  'partial-exit': 'neutral',
  'complete-impairment': 'info',
  'partial-impairment': 'info',
  shutdown: 'warning',
  'pre-shutdown': 'warning',
};

/**
 * 상태 배지 면 · 글자 — 모두 흰 글자(on.status), 면은 파운데이션 bg.status-*(foundation.config.json semantic.extra) — 구 서비스 배지 색 그대로(배지만 대비 예외, DD-71).
 * Badge 의 tone 색 위에 덮는다(2026-10-07 사용자 — 회수 · 부분회수 · 감액 등 흰 글씨로 통일, DD-70).
 * 투자 상태 배지 · 회수 배지 · 투자 카드의 평가 상태 띠가 같은 표를 쓴다
 */
export const STATUS_BADGE_CLASS: Record<InvestStatusBadgeType, string> = {
  'complete-exit': 'bg-bg-status-exit text-on-status',
  'partial-exit': 'bg-bg-status-partial-exit text-on-status',
  'complete-impairment': 'bg-bg-status-impairment text-on-status',
  'partial-impairment': 'bg-bg-status-impairment text-on-status',
  shutdown: 'bg-bg-status-shutdown text-on-status',
  'pre-shutdown': 'bg-bg-status-shutdown text-on-status',
};
